var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 200,
    viewBox: "0 0 218 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_6333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14478 49.4668V144.113C1.14478 146.054 2.18294 147.862 3.87476 148.823L83.1019 194.579C84.7937 195.559 86.87 195.559 88.5426 194.579L167.77 148.823C169.462 147.842 170.5 146.054 170.5 144.113V49.4668L85.8127 98.3565L1.14478 49.4668Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14502 49.4669L85.8321 0.577148L170.519 49.4669L85.8321 98.3759L1.14502 49.4669Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8469 68.3653L118.515 19.4756L137.586 30.4916L52.8991 79.4006L52.8606 116.005L33.8276 105.028L33.8469 68.3653Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.832 98.3755V194.848",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6047 158.935V175.104L44.4785 157.974V141.806L73.6047 158.935Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.978 200.373C196.257 200.373 217.561 179.069 217.561 152.79C217.561 126.511 196.257 105.208 169.978 105.208C143.699 105.208 122.396 126.511 122.396 152.79C122.396 179.069 143.699 200.373 169.978 200.373Z",
    fill: "#FACD22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.239 150.895V138.658C178.239 136.894 176.811 135.467 175.047 135.467C173.283 135.467 171.856 136.894 171.856 138.658",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.872 149.308V135.483C171.872 133.719 170.444 132.292 168.68 132.292C166.916 132.292 165.489 133.719 165.489 135.483V138.675",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.239 141.85C178.239 140.086 179.666 138.658 181.43 138.658C183.195 138.658 184.622 140.086 184.622 141.85V161.224C184.622 168.264 178.912 173.958 171.888 173.958H168.696C164.238 173.958 161.527 172.595 159.154 170.237L151.391 162.475C150.14 161.095 150.253 158.962 151.632 157.711C152.915 156.557 154.871 156.557 156.155 157.711L159.154 160.711V138.658C159.154 136.894 160.565 135.467 162.329 135.467C164.093 135.467 165.521 136.894 165.521 138.658V150.093",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_6333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.303,
    height: 200,
    fill: "white",
    transform: "translate(0.568115)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.5ee68a3c6b3f983bb3218d04309bc136.svg";
export { ForwardRef as ReactComponent };